export default __webpack_public_path__ + "static/media/s4biz-white.deecd08d.png";